import { HRIS_ACCESS_RIGHTS } from "@/constants/AccessRights";

export function buildHRISMenuItems(state) {
    var isHRISSelfService = state.isHRISSelfService;
    var isHRISHR = state.isHRISHR;
    var isHRISRecruitment = state.isHRISRecruitment;
    var isHRISWorkforce = state.isHRISWorkforce;
    var isHRISTimekeeping = state.isHRISTimekeeping;
    var isHRISRequests = state.isHRISRequests;

    var setIsHRISSelfService = state.setIsHRISSelfService;
    var setIsHRISHR = state.setIsHRISHR;
    var setIsHRISRecruitment = state.setIsHRISRecruitment;
    var setIsHRISWorkforce = state.setIsHRISWorkforce;
    var setIsHRISTimekeeping = state.setIsHRISTimekeeping;
    var setIsHRISRequests = state.setIsHRISRequests;

    var setIscurrentState = state.setIscurrentState;

    return [
        {
            id: "hris",
            label: "HRIS",
            icon: "ri-team-fill",
            link: "/#",
            subItems: [
                {
                    id: "hris-dashboard", label: "Dashboard", icon: "ri-bar-chart-2-fill",
                    link: "/hris/dashboards/main", parentId: "hris",
                    permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_DASHBOARD_EMPLOYEES],
                },

                {
                    id: "hris-self-service", label: "My Self-Service", icon: "ri-user-smile-fill",
                    link: "/#", parentId: "hris", isChildItem: true,
                    stateVariables: isHRISSelfService,
                    click: function (e) { e.preventDefault(); setIsHRISSelfService(!isHRISSelfService); setIscurrentState("HRISSelfService"); },
                    childItems: [
                        {
                            id: "hris-self-service-my-attendance", label: "My Attendance",
                            link: "/hris/self-service/my-attendance",
                            permissionTypeId: [],
                        },
                        {
                            id: "hris-self-service-my-goal-settings", label: "My Goal Setting",
                            link: "/hris/self-service/my-goal-settings",
                            permissionTypeId: [],
                        },
                        {
                            id: "hris-self-service-my-learning-development", label: "My Learning & Development",
                            link: "/hris/self-service/my-learning-development",
                            permissionTypeId: [
                            ],
                        },
                        {
                            id: "hris-self-service-my-leave-summary", label: "My Leave Summary",
                            link: "/hris/self-service/my-leave-summary",
                            permissionTypeId: [
                            ],
                        },
                    ],
                },
                {
                    id: "hris-hr", label: "HR", icon: "ri-team-fill",
                    link: "/#", parentId: "hris", isChildItem: true,
                    stateVariables: isHRISHR,
                    click: function (e) { e.preventDefault(); setIsHRISHR(!isHRISHR); setIscurrentState("HRISHR"); },
                    childItems: [
                        {
                            id: "hris-hr-employees", label: "Employees", icon: "ri-contacts-fill",
                            link: "/hris/hr/employees", parentId: "hris-hr",
                            permissionTypeId: [],
                        },
                        {
                            id: "hris-hr-plantilla", label: "Plantillas", icon: "ri-file-list-2-fill",
                            link: "/hris/hr/plantilla", parentId: "hris-hr",
                            permissionTypeId: [],
                        },
                        {
                            id: "hris-hr-leave-summary", label: "Leave Management", icon: "ri-file-list-2-fill",
                            link: "/hris/hr/leave-summary", parentId: "hris-hr",
                            permissionTypeId: [],
                        },
                        {
                            id: "hris-hr--disciplinary", label: "Disciplinary Actions", icon: "ri-file-list-2-fill",
                            link: "/hris/hr/disciplinary", parentId: "hris-hr",
                            permissionTypeId: [],
                        },
                        {
                            id: "hris-hr-separation", label: "Separation & Clearance", icon: "ri-file-list-2-fill",
                            link: "/hris/hr/separation", parentId: "hris-hr",
                            permissionTypeId: [],
                        },
                    ],
                },
                {
                    id: "hris-recruitment", label: "Recruitment", icon: "ri-user-search-fill",
                    link: "/#", parentId: "hris", isChildItem: true,
                    stateVariables: isHRISRecruitment,
                    click: function (e) { e.preventDefault(); setIsHRISRecruitment(!isHRISRecruitment); setIscurrentState("HRISRecruitment"); },
                    childItems: [
                        {
                            id: "hris-recruitment-applicants", label: "Applicants",
                            link: "/hris/recruitment/applicants", parentId: "hris-recruitment",
                            permissionTypeId: [],
                        },
                        {
                            id: "hris-recruitment-jobs", label: "Job Vacancies",
                            link: "/hris/recruitment/jobs", parentId: "hris-recruitment",
                            permissionTypeId: [],
                        },

                        {
                            id: "hris-recruitment-applicants-exams", label: "Applicant Exams",
                            link: "/hris/recruitment/applicants/exams", parentId: "hris-recruitment",
                            permissionTypeId: [],
                        },
                        {
                            id: "hris-recruitment-applicants-interviews", label: "Applicant Interviews",
                            link: "/hris/recruitment/applicants/interviews", parentId: "hris-recruitment",
                            permissionTypeId: [],
                        },

                        {
                            id: "hris-recruitment-contracts", label: "Appointment / Contract Offers",
                            link: "/hris/recruitment/contracts", parentId: "hris-recruitment",
                            permissionTypeId: [],
                        },
                    ],
                },
                {
                    id: "hris-workforce-development", label: "Workforce Development", icon: "ri-graduation-cap-fill",
                    link: "/#", parentId: "hris", isChildItem: true,
                    stateVariables: isHRISWorkforce,
                    click: function (e) { e.preventDefault(); setIsHRISWorkforce(!isHRISWorkforce); setIscurrentState("HRISWorkforce"); },
                    childItems: [
                        {
                            id: "hris-workforce-development-learning-development", label: "Learning & Development",
                            link: "/hris/workforce-development/learning-development",
                            permissionTypeId: [
                            ],
                        },
                        {
                            id: "hris-workforce-development-goal-settings", label: "Goal Setting",
                            link: "/hris/workforce-development/goal-settings",
                            permissionTypeId: [],
                        },
                        {
                            id: "hris-workforce-development-performance-evaluation", label: "Performance Evaluation",
                            link: "/hris/workforce-development/performance-evaluation",
                            permissionTypeId: [],
                        },
                        {
                            id: "hris-workforce-development-reward-recognition", label: "Rewards & Recognition",
                            link: "/hris/workforce-development/reward-recognition",
                            permissionTypeId: [],
                        },
                    ],
                },
                // {
                //     id: "hris-timekeeping", label: "Time & Leave", icon: "ri-calendar-check-fill",
                //     link: "/#", parentId: "hris", isChildItem: true,
                //     stateVariables: isHRISTimekeeping,
                //     click: function (e) { e.preventDefault(); setIsHRISTimekeeping(!isHRISTimekeeping); setIscurrentState("HRISTimekeeping"); },
                //     childItems: [
                //         {
                //             id: "hris-employee-attendance", label: "Employee Attendance",
                //             link: "/hris/employee-attendance",
                //             permissionTypeId: [],
                //         },
                //         {
                //             id: "hris-employee-leave-summary", label: "Leave Summary",
                //             link: "/hris/leave-summary",
                //             permissionTypeId: [
                //             ],
                //         },
                //     ],
                // },
                {
                    id: "hris-requests", label: "Requests", icon: "ri-graduation-cap-fill",
                    link: "/#", parentId: "hris", isChildItem: true,
                    stateVariables: isHRISRequests,
                    click: function (e) { e.preventDefault(); setIsHRISRequests(!isHRISRequests); setIscurrentState("HRISRequests"); },
                    childItems: [
                        {
                            id: "hris-requests-coe", label: "Certificate of Employment",
                            link: "/hris/transactions/coe",
                            permissionTypeId: [
                            ],
                        },
                        {
                            id: "hris-requests-leave", label: "Leave Requests",
                            link: "/hris/transactions/leave-requests",
                            permissionTypeId: [
                            ],
                        },
                    ],
                },
                // {
                //     id: "hris-transactions", label: "Transactions", icon: "ri-file-transfer-fill",
                //     link: "/hris/transactions", parentId: "hris",
                //     permissionTypeId: [
                //     ],
                // },
                {
                    id: "hris-reports", label: "Reports", icon: "ri-article-line",
                    link: "/hris/reports", parentId: "hris",
                    permissionTypeId: [],
                },
                {
                    id: "hris-settings", label: "Settings", icon: "ri-settings-2-fill",
                    link: "/hris/settings", parentId: "hris",
                    permissionTypeId: [
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_EDUCATIONLEVELS,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_EMPLOYMENTTYPES,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_HOLIDAYTYPES,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_LEAVETYPES,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_NATIONALITIES,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_OFFICES,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_POSITIONS,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_RELATIONSHIPTYPES,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SALARYMATRIX,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SALARYTYPES,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SCHOOLS,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SEPARATIONTYPES,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SERVICERECORDTYPES,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SKILLS,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_TRAININGPROGRAMS,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_TRAININGTARGETS,
                        HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_WORKSCHEDULES,
                    ],
                },
            ],
        },
    ];
}